<div fxLayout="row" fxLayoutAlign="start" id="login">
  <div fxLayout="column"
       fxLayoutAlign="start" style="width: 100%">
    <ng-container *ngTemplateOutlet="LoginFieldsDiv;"></ng-container>
  </div>

  <div *eCaseIfOnDom [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}"
       id="login-form-wrapper">

    <div>
      <div fxLayout="row" fxLayoutAlign="space-between">
        <div fxFlex="40">
        </div>
      </div>
      <div id="login-form">
        <main>
          <div class="title" style="color:black !important">
              <p>
                  Le portail est actuellement indisponible. Notre équipe travaille activement à rétablir son
                  fonctionnement.
              </p>
              <p>
                  Nous nous excusons pour les désagréments occasionnés et vous invitons à réessayer ultérieurement.
              </p>
              <hr/>
              <p>The portal is temporarily unavailable. Our team is actively working to restore service as quickly as
                  possible.</p>
              <p>We apologize for any inconvenience this may cause and thank you for your patience. Please try again
                  later.</p>
          </div>
        </main>
      </div>
    </div>

    <div>
      <div class="footer" fxLayout="row" fxLayoutAlign="end center">
        <span class="footerText">Powered by / Propulsé par</span>
        <img [src]="'/assets/images/logos/syntoLogo.svg'" alt="eVision Synto Logo"
             style="height:25px;">
      </div>
    </div>
  </div>
</div>


<ng-template #LoginFieldsDiv>
  <div fxFlex fxHide fxShow.gt-xs id="login-intro">
    <div *eCaseIfOnDom [@animate]="{value:'*',params:{scale:'0.1'}}" class="logo">
      <img [src]="'/assets/images/logos/syntoLogo.svg'"
           alt="Synto product logo"
           class="logoImg"
           style="filter: drop-shadow(0px 0px 5px #000);">
    </div>
   <!-- <div *eCaseIfOnDom [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}"
         class="title">
      Welcome to Synto / Bienvenue sur Synto
    </div>
    <div *eCaseIfOnDom [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}"
         class="subtitle">
      Research Grants Management System / Système de gestion du financement et de la conformité
    </div>-->
  </div>
</ng-template>


